module.exports = __webpack_public_path__ + "static/media/zuzhijigou.0fae674a.jpg";